'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeRte = require('@shopify/theme-rte');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rteWrappers = function rteWrappers() {
  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  (0, _themeRte.wrapTable)({
    $tables: (0, _jquery2.default)(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper'
  });

  // Target iframes to make them responsive
  var iframeSelectors = '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"]';

  (0, _themeRte.wrapIframe)({
    $iframes: (0, _jquery2.default)(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });
};

exports.default = rteWrappers;